const url = window.location.href;

export const CURRENT_APP_LIVEVIDEO = 'CurrentApp/LIVEVIDEO';
export const CURRENT_APP_LIVEPROJECT = 'CurrentApp/LIVEPROJECT';
export const LIVEVIDEO_COURSE_TYPE = 'LIVEVIDEO';
export const LIVEPROJECT_COURSE_TYPE = 'PBC'; 
export const OPEN_LIVEPROJECT_IN_LOCALHOST = (true || getParameterByName("liveProject") == "true") && getParameterByName("liveVideo") != "true";
export const FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND = false;
export const FIX_GRAPHICAL_DND_ERRORS = true;
export const FORCE_TONI_DEV: boolean = (false || getParameterByName("toniDev") == "true") && url?.indexOf("localhost") !== -1;
export const FORCE_LOCAL_BACKEND_DEV: boolean = (false || getParameterByName("localDev") == "true") && url?.indexOf("localhost") !== -1;

/**
 * THEMES
 */
export const LIVEVIDEO_DEFULT_THEME = 'APP/THEME/LIVEVIDEO_DEFAULT_THEME';
export const LIVEPROJECT_PURPLE_THEME = 'APP/THEME/LIVEPROJECT_PURPLE_THEME';
export const LIVEPROJECT_BLUE_THEME = 'APP/THEME/LIVEPROJECT_BLUE_THEME';
export const LIVEPROJECT_DEFULT_THEME = 'APP/THEME/LIVEPROJECT_DEFAULT_THEME';

export const INCREMENT_COUNTER = 'App/INCREMENT_COUNTER';
export const DECREMENT_COUNTER = 'App/DECREMENT_COUNTER';
export const SET_VIDEO_DURATION = 'videoInformation/SET_VIDEO_DURATION';
export const REQUEST_CONSUMED = 'videoInformation/REQUEST_CONSUMED';
export const SET_MEDIA_ELEMENT = 'videoInformation/SET_MEDIA_ELEMENT';
export const SET_PREV_SOURCE_USED_FOR_ON_CAN_PLAY = 'videoInformation/SET_PREV_SOURCE_USED_FOR_ON_CAN_PLAY';
export const SET_CUE_TRACK = 'videoInformation/SET_CUE_TRACK';
export const SET_CHANGED_VIDEO_SRC = 'videoInformation/SET_CHANGED_VIDEO_SRC';
export const IS_MOBILE = 'videoInformation/IS_MOBILE';
export const IS_CUE_CHANGED = 'videoInformation/IS_CUE_CHANGED';
export const SET_MEDIA_ELEMENT_PROPERTIES = 'mediaElementActions/SET_MEDIA_ELEMENT_PROPERTIES';
export const SET_INITIAL_QUIZ_CONSUMPTION = 'exerciseTimelineControl/SET_INITIAL_QUIZ_CONSUMPTION';
export const SET_INITIAL_TRY_IT_YOURSELF_CONSUMPTION = 'exerciseTimelineControl/SET_INITIAL_TRY_IT_YOURSELF_CONSUMPTION';
export const SET_INITIAL_CODE_LISTING_CONSUMPTION = 'codeListingTimelineControl/SET_INITIAL_CODE_LISTING_CONSUMPTION';
export const SET_INITIAL_QUIZ_EXERCIZE_SHOWN_OR_NOT = 'tryItYourselfTimelineControl/SET_INITIAL_QUIZ_EXERCIZE_SHOWN_OR_NOT';
export const SET_INITIAL_IMAGES_SHOWN_OR_NOT = 'exerciseTimelineControl/SET_INITIAL_IMAGES_SHOWN_OR_NOT';
export const SET_INITIAL_VIDEOSCREENSHOTS_SHOWN_OR_NOT = 'exerciseTimelineControl/SET_INITIAL_VIDEOSCREENSHOTS_SHOWN_OR_NOT';
export const SET_INITIAL_FILEUPLOADS_SHOWN_OR_NOT = 'exerciseTimelineControl/SET_INITIAL_FILEUPLOADS_SHOWN_OR_NOT';
export const SET_VIDEOSCREENSHOTS_SHOWN_OR_NOT_BUT_ONLY_MERGE = 'exerciseTimelineControl/SET_VIDEOSCREENSHOTS_SHOWN_OR_NOT_BUT_ONLY_MERGE';
export const SET_INITIAL_CODELISTINGS_SHOWN_OR_NOT = 'exerciseTimelineControl/SET_INITIAL_CODELISTINGS_SHOWN_OR_NOT';
export const SET_INITIAL_TRYITYOURSELF_SHOWN_OR_NOT = 'exerciseTimelineControl/SET_INITIAL_TRYITYOURSELF_SHOWN_OR_NOT';
export const SET_TRYITYOURSELF_CHANGED_AND_CODE = 'exerciseTimelineControl/SET_TRYITYOURSELF_CHANGED_AND_CODE';
export const UPDATE_TRYITYOURSELF_CHANGED_AND_CODE = 'exerciseTimelineControl/UPDATE_TRYITYOURSELF_CHANGED_AND_CODE';
export const SET_CODELISTING_CHANGED_AND_CODE = 'exerciseTimelineControl/SET_CODELISTING_CHANGED_AND_CODE';
export const SET_INITIAL_TEXT_EDITOR_SHOWN_OR_NOT = 'exerciseTimelineControl/SET_INITIAL_TEXT_EDITOR_SHOWN_OR_NOT';
export const SET_QUIZ_ID_TO_SHOW = 'exerciseTimelineControl/SET_QUIZ_ID_TO_SHOW';
export const SET_INLINE_QUIZ_EXPANDED_STATE = 'exerciseTimelineControl/SET_INLINE_QUIZ_EXPANDED_STATE';
export const CLOSE_ALL_INLINE_QUIZZES = 'exerciseTimelineControl/CLOSE_ALL_INLINE_QUIZZES';
export const SET_TOGGLE_TEXT_STATUS_NEW_CUE = 'exerciseTimelineControl/SET_TOGGLE_TEXT_STATUS_NEW_CUE';
export const SET_PULSATING_BUTTON_TIMING_INFO = 'exerciseTimelineControl/SET_PULSATING_BUTTON_TIMING_INFO';
export const SET_CONSUMPTION_SCROLL_TO_PULSATING = 'exerciseTimelineControl/SET_CONSUMPTION_SCROLL_TO_PULSATING';
export const SET_DATA_FOR_VIDEO_SCREENSHOTS = 'mediaElementActions/SET_DATA_FOR_VIDEO_SCREENSHOTS';
export const PREV_NUMBER_OF_TEXT_EDITOR = 'mediaElementActions/PREV_NUMBER_OF_TEXT_EDITOR';
export const PREV_NUMBER_OF_LIVEBOOK_VIEWER = 'mediaElementActions/PREV_NUMBER_OF_LIVEBOOK_VIEWER';
export const SET_NEW_COLORPICKER_COLOR = 'mediaElementActions/SET_NEW_COLORPICKER_COLOR';
export const PREV_AND_NEXT_MODULE_DATA = 'mediaElementActions/PREV_AND_NEXT_MODULE_DATA';
export const SET_NEW_IMAGES_RAWDATA = 'mediaElementActions/SET_NEW_IMAGES_RAWDATA';
export const SET_NEW_TEXT_EDITOR_RAWDATA = 'mediaElementActions/SET_NEW_TEXT_EDITOR_RAWDATA';
export const SET_NEW_LIVEBOOK_VIEWER_RAWDATA = 'mediaElementActions/SET_NEW_LIVEBOOK_VIEWER_RAWDATA';
export const SET_NEW_CODE_LISTINGS_RAWDATA = 'mediaElementActions/SET_NEW_CODE_LISTINGS_RAWDATA';
export const SET_NEW_TRY_IT_YOURSELF_RAWDATA = 'mediaElementActions/SET_NEW_TRY_IT_YOURSELF_RAWDATA';
export const SET_NEW_VIDEO_SCREENSHOTS_RAWDATA = 'mediaElementActions/SET_NEW_VIDEO_SCREENSHOTS_RAWDATA';
export const SET_NEW_FILE_UPLOADS_RAWDATA = 'mediaElementActions/SET_NEW_FILE_UPLOADS_RAWDATA';
export const SET_NEW_QUIZZES_RAWDATA = 'mediaElementActions/SET_NEW_QUIZZES_RAWDATA';
export const SET_RESET_MEDIA_QUIZ_RAW_DATA = 'mediaElementActions/SET_RESET_MEDIA_QUIZ_RAW_DATA';
export const SET_COURSE_DETAILS = 'mediaElementActions/SET_COURSE_DETAILS';
export const SET_COURSE_ID_DATA = 'mediaElementActions/SET_COURSE_ID_DATA';
export const SET_USERS_SISTER_LICENSES = 'licenses/SET_USERS_SISTER_LICENSES';
export const NO_OF_DELIVERABLE_MODULES = 'licenses/NO_OF_DELIVERABLE_MODULES';
export const SET_COURSE_SLUGS = 'mediaElementActions/SET_COURSE_SLUGS';
export const SET_ALL_SLUGS = 'mediaElementActions/SET_ALL_SLUGS';
export const SET_HIGHLIGHT_WHOLE_PARAGRAPH = 'mediaElementActions/SET_HIGHLIGHT_WHOLE_PARAGRAPH';
export const SET_DISCUSSION_SETTINGS = 'mediaElementActions/SET_DISCUSSION_SETTINGS';
export const SET_DISCUSSION_VISIBLE = 'mediaElementActions/SET_DISCUSSION_VISIBLE';
export const SET_DISCUSSION_READY = 'mediaElementActions/SET_DISCUSSION_READY';
export const SET_SHOULD_DISPLAY_USER_OPTIONS_INSTEAD_OF_DISCUSSIONS = 'liveProject/SET_SHOULD_DISPLAY_USER_OPTIONS_INSTEAD_OF_DISCUSSIONS';
export const SET_DISCUSSION_WIDTH = 'mediaElementActions/SET_DISCUSSION_WIDTH';
export const IS_DISCUSSION_BEING_DRAGGED = 'mediaElementActions/IS_DISCUSSION_BEING_DRAGGED';
export const SET_ALLOW_VIDEO_PAUSE = 'mediaElementActions/SET_ALLOW_VIDEO_PAUSE';
export const SET_ALLOW_PLAYBACK = 'mediaElementActions/SET_ALLOW_PLAYBACK';
export const EXERCISE_CHANGES_TO_PROCESS = 'mediaElementActions/EXERCISE_CHANGES_TO_PROCESS';
export const FORCE_RESUME_VIDEO = 'mediaElementActions/FORCE_RESUME_VIDEO';
export const SET_IS_VIDEO_VISIBLE = 'mediaElementActions/SET_IS_VIDEO_VISIBLE';
export const SET_TEMP_DISABLED_EXERCISE_EDITING = 'mediaElementActions/SET_TEMP_DISABLED_EXERCISE_EDITING';
export const SET_IS_LOGGED_IN = 'sso/SET_IS_LOGGED_IN';
export const SET_SHOULD_CHECK_LOGIN_ON_BACKEND = 'sso/SET_SHOULD_CHECK_LOGIN_ON_BACKEND';
export const SET_JSON_NOTIFICATION = 'notification/SET_JSON_NOTIFICATION';
export const EDIT_JSON_NOTIFICATION = 'notification/EDIT_JSON_NOTIFICATION';
export const REMOVE_JSON_NOTIFICATION = 'notification/REMOVE_JSON_NOTIFICATION';
export const SET_JSON_NOTIFICATION_V2 = 'notification/SET_JSON_NOTIFICATION_V2';
export const EDIT_JSON_NOTIFICATION_V2 = 'notification/EDIT_JSON_NOTIFICATION_V2';
export const REMOVE_JSON_NOTIFICATION_V2 = 'notification/REMOVE_JSON_NOTIFICATION_V2';
export const SHOW_HEADER_NOTIFICATION = 'notification/SHOW_HEADER_NOTIFICATION';
export const REMOVE_HEADER_NOTIFICATION = 'notification/REMOVE_HEADER_NOTIFICATION';
export const SET_USER_HAS_ACCESS = 'general/SET_USER_HAS_ACCESS';
export const SET_IS_TRANSCRIPT_VISIBLE = 'meap/SET_IS_TRANSCRIPT_VISIBLE';
export const SET_IS_VIDEO_FRAGMENT_FRAME_VISIBLE = 'micro/SET_IS_VIDEO_FRAGMENT_FRAME_VISIBLE';
export const SET_CAN_VIDEO_BE_PLAYED = 'video/SET_CAN_VIDEO_BE_PLAYED';
export const SET_CURRENT_SPEED = 'video/SET_CURRENT_SPEED';
export const RECEIVE_COMMENT_NOTIF_EMAILS = 'video/RECEIVE_COMMENT_NOTIF_EMAILS';
export const RECEIVE_COMMENT_NOTIF_EMAILS_IMMEDIATELY = 'video/RECEIVE_COMMENT_NOTIF_EMAILS_IMMEDIATELY';
export const SET_IS_VIDEO_READY = 'video/SET_IS_VIDEO_READY';
export const SET_ARE_CC_ENABLED = 'video/SET_ARE_CC_ENABLED';
export const SET_IS_TRANSCRIPT_READY = 'transcript/SET_IS_TRANSCRIPT_READY';
export const SET_CUESPAN_TIMESTAMPS = 'cuespan/SET_CUESPAN_TIMESTAMPS';
export const SET_SEARCH_TERMS = 'search/SET_SEARCH_TERMS';
export const FORCE_UPDATE_CUE_SPANS = 'main/FORCE_UPDATE_CUE_SPANS';
export const FORCE_HIGHLIGHT_PARAGRAPHS = 'main/FORCE_HIGHLIGHT_PARAGRAPHS';
export const NOTIFY_PARAGRAPH_CHANGE = 'main/NOTIFY_PARAGRAPH_CHANGE';
export const NOTIFY_TRANSCRIPT_CHANGE = 'main/NOTIFY_TRANSCRIPT_CHANGE';
export const SET_OLD_LOADER_HIDDEN = 'main/SET_LOADER_HIDDEN';
export const MARK_SELECTED_CUE_ID = 'main/MARK_SELECTED_CUE_ID';
export const IS_TOC_VISIBLE = 'toc/IS_TOC_VISIBLE';
export const SET_DISABLED_CUE_SRC_EDITING = 'edit_module/SET_DISABLED_CUE_SRC_EDITING';
export const SET_CALENDAR_EVENTS = 'liveproject/SET_CALENDAR_EVENTS';
export const SET_LP_DASHBOARD_SIDEBAR_VISIBILITY = 'liveproject/SET_LP_DASHBOARD_SIDEBAR_VISIBILITY';
export const SET_UPCOMING_EVENTS = 'liveproject/SET_UPCOMING_EVENTS';
export const SET_RECENT_ACTIVITY = 'liveproject/SET_RECENT_ACTIVITY';
export const SET_COURSE_MENTORS = 'liveproject/SET_COURSE_MENTORS';
export const SET_COURSE_AUTHORS = 'liveproject/SET_COURSE_AUTHORS';
export const SET_GROUP_MEMBER_DATA = 'liveproject/SET_GROUP_MEMBER_DATA';
export const SET_ONLINE_USERS = 'liveproject/SET_ONLINE_USERS';
export const SET_SECTION_ID = 'liveproject/SET_SECTION_ID';
export const SET_LP_LICENSES = 'liveproject/SET_LP_LICENSES';

export const SET_HAS_FEEDBACK = "SET_HAS_FEEDBACK";

export const SET_UNSCRAMBLED_VIDEO_FRAGMENT_DATA = 'porous/SET_UNSCRAMBLED_VIDEO_FRAGMENT_DATA';
export const SET_SCRAMBLED_VIDEO_DURATION = 'porous/SET_SCRAMBLED_VIDEO_DURATION';
export const SET_LIST_OF_PARAGRAPHS_TO_UNSCRAMBLE = 'porous/SET_LIST_OF_PARAGRAPHS_TO_UNSCRAMBLE';
export const SET_PARAGRAPH_FOR_LOCK_ICON_SHOW_INDEX = 'porous/SET_PARAGRAPH_FOR_LOCK_ICON_SHOW_INDEX';
export const ADD_UNSCRAMBLED_PARAGRAPHS_TO_LIST = 'porous/ADD_UNSCRAMBLED_PARAGRAPHS_TO_LIST';
export const FORCE_SHOW_SCRAMBLED_NOTIFICATION = 'porous/FORCE_SHOW_SCRAMBLED_NOTIFICATION';
export const SET_ARE_ALL_PARAGRAPHS_ALREADY_UNSCRAMBLED = 'porous/SET_ARE_ALL_PARAGRAPHS_ALREADY_UNSCRAMBLED';
export const SET_IS_MEAP = 'general/SET_IS_MEAP';
export const SET_MODULE_TYPE = 'general/SET_MODULE_TYPE';
export const SET_MODULE_ID = 'general/SET_MODULE_ID';
export const SET_LV_VIEWER_TYPE = 'general/SET_LV_VIEWER_TYPE';
export const SET_DELIVERABLE_REACHED_ACCESS = 'general/SET_DELIVERABLE_REACHED_ACCESS';
export const SET_DELIVERABLE_REACHED_ACCESS_REASON = 'general/SET_DELIVERABLE_REACHED_ACCESS_REASON';
export const SET_MSS = 'general/SET_MSS';
export const SET_USER_PROGRESS_REDUX = 'userData/SET_USER_PROGRESS_REDUX';
export const SET_SHOULD_SHOW_PREVIEW_OF_EXERCISE_FOR_CERT_TEST = 'certificate/SET_SHOULD_SHOW_PREVIEW_OF_EXERCISE_FOR_CERT_TEST';

export const SET_NEW_MODULE_NAME = 'editors/SET_NEW_MODULE_NAME';
export const SET_USER_EXERCISES_RESULTS = 'EXERICISES/SET_USER_EXERCISES_RESULTS';
export const SET_USER_CERTIFICATE_TEST_RESULTS = 'EXERICISES/SET_USER_CERTIFICATE_TEST_RESULTS';
export const SET_USER_HAS_PASSED_TEST = 'EXERICISES/SET_USER_HAS_PASSED_TEST';
export const SET_USER_HAS_ALL_DELIVERABLES_APPROVED = 'EXERICISES/SET_USER_HAS_ALL_DELIVERABLES_APPROVED';

export const SET_NUMBER_OF_TOKENS = 'tokens/SET_NUMBER_OF_TOKENS';
export const SET_TOKEN_UNLOACKED_STATUS = 'tokens/SET_TOKEN_UNLOACKED_STATUS';
export const SET_USER_HAS_ACCESS_TO_COURSE = 'user/SET_USER_HAS_ACCESS_TO_COURSE';
export const SET_USER_HAS_CERTIFICATE_FOR_COURSE = 'user/SET_USER_HAS_CERTIFICATE_FOR_COURSE';
export const SET_LICENSE_TIER = 'user/SET_LICENSE_TIER';
export const SET_NUMBER_OF_LP_USERS = 'user/SET_NUMBER_OF_LP_USERS';
export const SET_SISTER_OFFERINGS = 'lp/SET_SISTER_OFFERINGS';
export const SET_HAS_STARTED_LP_SISTER_OFFERINGS = 'lp/SET_HAS_STARTED_LP_SISTER_OFFERINGS';
export const SET_SISTER_LICENSES_START_DATE = 'lp/SET_SISTER_LICENSES_START_DATE';
export const SET_USER_HAS_INVISIBLE_MODULE_ACCESS = 'course/SET_USER_HAS_INVISIBLE_MODULE_ACCESS';
export const SET_IS_TEXT_ONLY_EXERCISE_VISIBLE = 'course/SET_IS_TEXT_ONLY_EXERCISE_VISIBLE';
export const SET_WINDOW_VISIBILITY = 'general/SET_WINDOW_VISIBILITY';
export const SET_IS_VIDEO_CURRENTLY_PLAYING = 'general/SET_IS_VIDEO_CURRENTLY_PLAYING';


export const SET_MANAGE_GROUPS_GROUPS_DATA = 'groups_manager/SET_MANAGE_GROUPS_GROUPS_DATA';
export const SET_MANAGE_GROUP_SESSIONS_DATA = 'groups_manager/SET_MANAGE_GROUP_SESSIONS_DATA';
export const SET_MANAGE_GROUPS_SET_SELECTED_GROUP_ID = 'groups_manager/SET_MANAGE_GROUPS_SET_SELECTED_GROUP_ID';
export const SET_MANAGE_GROUPS_USERS_DATA = 'groups_manager/SET_MANAGE_GROUPS_USERS_DATA';
export const SET_MANAGE_GROUPS_MENTORS_DATA = 'groups_manager/SET_MANAGE_GROUPS_MENTORS_DATA';
export const SET_FILTER_TEXT_GROUPS_MANAGER = 'groups_manager/SET_FILTER_TEXT_GROUPS_MANAGER';
export const SET_GROUPS_MANAGER_SESSION_ID = 'groups_manager/SET_GROUPS_MANAGER_SESSION_ID';
export const SET_FILTER_GROUP_TYPE = 'groups_manager/SET_FILTER_GROUP_TYPE';

export const SET_GROUPS_FOR_USER = 'groups/SET_GROUPS_FOR_USER';
export const SET_WERE_GROUPS_FOR_USER_PREPARED = 'groups/SET_WERE_GROUPS_FOR_USER_PREPARED';
export const SET_USER_SUBMISSIONS = 'groups/SET_USER_SUBMISSIONS';
export const SET_MENTORUI_USER_DATA = 'groups/SET_MENTORUI_USER_DATA';
export const SET_CURRENT_USER_SUBMISSION_STATUS = 'groups/SET_CURRENT_USER_SUBMISSION_STATUS';
export const SET_ACTIVE_USER_GROUP = 'groups/SET_ACTIVE_USER_GROUP';
export const SET_IS_INITIAL_ACTIVE_GROUP_SET = 'groups/SET_IS_INITIAL_ACTIVE_GROUP_SET';
export const SET_IS_MENTOR_FOR_THIS_COURSE = 'groups/SET_IS_MENTOR_FOR_THIS_COURSE';
export const SET_DELIVERABLE_DETAILS = 'deliverable/SET_DELIVERABLE_DETAILS';
export const SET_IS_DELIVERABLES_COMPLETED = 'deliverable/SET_IS_DELIVERABLES_COMPLETED';
export const SET_SHOULD_SHOW_ACHIEVEMENT_SCREEN = 'deliverable/SET_SHOULD_SHOW_ACHIEVEMENT_SCREEN';
export const FORCE_CHECK_ACHIEVEMENT = 'groups/FORCE_CHECK_ACHIEVEMENT';

export const GROUPS_REGISTER_EXISTING_USER_DATA = "groupsRegister/GROUPS_REGISTER_EXISTING_USER_DATA";
export const GROUPS_REGISTER_INITIAL_USER_DATA = "groupsRegister/GROUPS_REGISTER_INITIAL_USER_DATA";
export const GROUPS_REGISTER_USER_LOCATION = "groupsRegister/GROUPS_REGISTER_USER_LOCATION";
export const GROUPS_REGISTER_USER_DESCRIBE_YOURSELF = "groupsRegister/GROUPS_REGISTER_USER_DESCRIBE_YOURSELF";
export const GROUPS_REGISTER_USER_GENERAL_SKILL_LEVEL = "groupsRegister/GROUPS_REGISTER_USER_GENERAL_SKILL_LEVEL";
export const GROUPS_REGISTER_USER_LANGUAGE = "groupsRegister/GROUPS_REGISTER_USER_LANGUAGE";
export const GROUPS_REGISTER_SET_AVAILALE_GROUPS = "groupsRegister/GROUPS_REGISTER_SET_AVAILALE_GROUPS";

export const SET_WILL_PAGE_BE_RELOADED = "general/SET_WILL_PAGE_BE_RELOADED";
export const IS_WELCOME_TO_NEW_LP_MODAL_SHOWN = "liveProject/IS_WELCOME_TO_NEW_LP_MODAL_SHOWN";
export const SHOW_PROFILE_MODAL = "liveProject/SHOW_PROFILE_MODAL";
export const SHOULD_REDIRECT_TO_PROFILE = "liveProject/SHOULD_REDIRECT_TO_PROFILE";

export const SET_SKILL_DOMAIN_POOL = "skills/SET_SKILL_DOMAIN_POOL";

export const SET_IS_IDLE = "user/SET_IS_IDLE";

export const ARE_MICROTRANSACTIONS_ENABLED = 'general/ARE_MICROTRANSACTIONS_ENABLED';
export const MICRO_ENABLED_BOOLEAN: boolean = false;
export const HYBRID_SUPPORT_FOR_MICROS: boolean = false;

export const SHOULD_DISABLE_CONTROLS_IN_VIDEO: boolean = true;
export const IE_AND_EDGE_DELAY_FOR_DISABLE_CONTROLS: number = 600;
export const FORCE_FS_ELEMENT_IN_SAFARI: boolean = false;

export const IS_AUTOPLAY_ENABLED_FOR_ANDROID: boolean = false;
export const IS_AUTOPLAY_ENABLED_FOR_IOS: boolean = false;

export const COUNT_TEXT_MODULES_ENABLED: boolean = true;

export const FIND_AND_HIGHLIGHT_CUSTOM_STYLED_ELEMENTS_IN_TEXT: boolean = false;

export const PROGRESS_WEIGHT_IN_SECONDS_FOR_NON_VIDEO_MODULES: number = 1000;
/*if( getParameterByName("disableHighlighting")=="true"){
   FIND_AND_HIGHLIGHT_CUSTOM_STYLED_ELEMENTS_IN_TEXT=false;
}*/

/**
 * MODULE TYPES
 */

export const VIDEO_MODULE_TYPE = 'video';
export const TEXT_MODULE_TYPE = 'text';
export const EXERCISE_MODULE_TYPE = 'exercise';
export const DELIVERABLE_MODULE_TYPE = 'deliverable';
export const LIVEVIDEO_VIEWER_MODULE_TYPE = 'lvViewer';
export const CERTIFICATE_TEST_MODULE_TYPE = 'certTest';
export const COURSE_FEEDBACK_MODULE_TYPE = 'courseFeedback';

/**
 * Exercises type
 */

export const INLINE_EXERCISE_TITLE = "inline";
export const EXPANDED_EXERCISE_TITLE = "expanded";

/**
 * License TIER
 */

export const BASIC = "BASIC"; //Remove later !!!
export const SOLO = "SOLO";
export const MENTORED = "MENTORED";
export const STAFF = "STAFF";

/**
 * EDIT COURSE
 */

export const EDIT_COURSE_SET_COURSE_ID = 'editCourse/EDIT_COURSE_SET_COURSE_ID';
export const EDIT_COURSE_SET_COURSE_DATA = 'editCourse/EDIT_COURSE_SET_COURSE_DATA';
export const EDIT_COURSE_SET_IS_CREATE_NEW_COURSE = 'editCourse/EDIT_COURSE_SET_IS_CREATE_NEW_COURSE';
export const EDIT_COURSE_SET_IS_TRANSCRIPTION_ENABLED = 'editCourse/EDIT_COURSE_SET_IS_TRANSCRIPTION_ENABLED';
export const EDIT_COURSE_SET_IS_UNIT_REORDER_ENABLED = 'editCourse/EDIT_COURSE_SET_IS_UNIT_REORDER_ENABLED';
export const EDIT_COURSE_SET_IS_MODULE_REORDER_ENABLED = 'editCourse/EDIT_COURSE_SET_IS_MODULE_REORDER_ENABLED';
export const EDIT_COURSE_SET_MODULE_TYPE_OPTIONS_INDEX = 'editCourse/EDIT_COURSE_SET_MODULE_TYPE_OPTIONS_INDEX';
export const EDIT_COURSE_SET_CURRENTLY_EDITED = 'editCourse/EDIT_COURSE_SET_CURRENTLY_EDITED';
export const EDIT_COURSE_SET_WAS_ORDER_CHANGED = 'editCourse/EDIT_COURSE_SET_WAS_ORDER_CHANGED';
export const EDIT_COURSE_SET_TRANSCRIBE_SERVICE = 'editCourse/EDIT_COURSE_SET_TRANSCRIBE_SERVICE';
export const SET_CONTENT_FEEDBACK_STORE = "editCourse/SET_CONTENT_FEEDBACK_STORE";

/**
 * EDIT COURSE FINISHED
 */

export const TRANSCRIPT_HIDDEN_GETITS_VISIBLE: boolean = true;
export const TRANSCRIPT_HIDDEN_TRYITS_VISIBLE: boolean = true;
export const TRANSCRIPT_HIDDEN_CODELISTINGS_VISIBLE: boolean = true;
export const TRANSCRIPT_HIDDEN_VIDEOSCREENSHOT_VISIBLE: boolean = false;
export const TRANSCRIPT_HIDDEN_FILEUPLOAD_VISIBLE: boolean = true;
export const TRANSCRIPT_HIDDEN_IMAGE_VISIBLE: boolean = false;
export const TRANSCRIPT_HIDDEN_PARAGRAPHS_VISIBLE: boolean = true;
export const TRANSCRIPT_HIDDEN_HEADINGS_VISIBLE: boolean = false;
export const TRANSCRIPT_HIDDEN_HEADINGS_VISIBLE_AT_TOP_OF_TRANSCRIPT: boolean = true;
export const TRANSCRIPT_HIDDEN_PAGEBREAKS_VISIBLE: boolean = false;
export const TRANSCRIPT_HIDDEN_LIVEBOOK_VIEWERS_VISIBLE: boolean = false;

export const LOGIN_FORM_RESET = 'login/RESET';
export const LOGIN_FORM_FORCE_LOGIN_REFRESH = 'login/FORM_FORCE_LOGIN_REFRESH';
export const LOGIN_FORM_SET_USERNAME = 'login/LOGIN_FORM_SET_USERNAME';
export const LOGIN_FORM_SET_PASSWORD = 'login/LOGIN_FORM_SET_PASSWORD';

export const PREVIEW = 'PREVIEW';
export const FREE = 'FREE';
export const UNIT = 'unit';
export const MILESTONE = 'milestone';
export const MODULE = 'module';
export const CONTENT_MODULE = 'content module';
export const DELIVERABLE = 'deliverable';
export const CERTIFICATE_TEST = 'certificate test';
export const COURSE_FEEDBACK = 'feedback';
export const LIVEVIDEO_VIEWER = 'liveVideo viewer';

export const LOGIN_USER_PENDING = 'App/LOGIN_USER_PENDING';
export const LOGIN_USER_SUCCESS = 'App/LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'App/LOGIN_USER_ERROR';

export const LOGOUT_USER = 'App/LOGOUT_USER';
export const REFRESH_LOGIN_USER = 'App/REFRESH_LOGIN_USER';

export const PERMISSION_ERR_MSG = `
  You do not have permission to view this page.
`;
export const PERMISSION_PROMO_ERR_MSG = `
  You do not have permission to view this page. This is not a free module.
`;
export const PERMISSION_COURSE_ERR_MSG = `
  You do not have permission to view this page. You do not own this course.
`;
export const PERMISSION_ERR_MSG_LOGIN = `
  Please log-in. This page is under construction.
`;
export const FEATURE_NOT_SUPPORTED = `
  This feature is not available for this course type.
`;
export const NOT_PART_OF_A_GROUP = `
  You are not member of any group in this course.
`;
export const DELIVERABLE_CLOSED = `
  Unfortunately, deliverable submissions are not open yet.
`;
export const COURSE_NOT_FOUND = `
  Course not found.
`;
export const CERTIFICATE_TEST_NOT_EDITABLE = `
  Certificate test modules are not editable.
Please, edit each exercise individually.
`;
  
export const NO_GROUP_CHOSEN_ABOUT_GROUP = `
   Click on a group to get more information about the group
`;

export const NO_GROUP_CHOSEN_DISCUSSIONS = `
   Click on a group to peek into a group’s chat
`;

export const REJECT_PERMISSION_ERROR_403_401 = "Unfortunatelly, you do not have permission to access this page!";

export const AMOUNT_TO_SAVE_EDIT_COURSE_SCROLL_AND_COLLAPSED = 5 * 60 * 1000;
export const AMOUNT_TO_SAVE_GROUP_SATISFIED = 7 * 24 * 60 * 60 * 1000;
export const AMOUNT_TO_SAVE_GROUP_SATISFIED_LONG = 99999 * 24 * 60 * 60 * 1000;


export const ROLE_IVC_ADMIN = 'userRoles/ROLE_IVC_ADMIN'
export const ROLE_USER = 'userRoles/ROLE_USER'
export const ROLE_IVC_EDITOR = 'userRoles/ROLE_IVC_EDITOR'
export const ROLE_IVC_AUTHOR = 'userRoles/ROLE_IVC_AUTHOR'
export const ROLE_IVC_MENTOR = 'userRoles/ROLE_IVC_MENTOR'

export const MANUAL_TIMESTAMP_IDENTIFIER = '77dzgd86276df3476gfiuj5nf7936tfgd3uhdi3g4';

export const YEAR_FOR_PROMOTION: number = 2019;
export const MONTH_FOR_PROMOTION: number = 8; //From 1
export const PROMOTION_DISCOUNT_PRICE: string = "$25"; //From 1

//DND
export const DNDTypes = {
   MODULE: 'module'
};


export enum DeploymentType {
   dev,
   qa,
   prod,
   docker
}

export enum DeliverableAccessReason {
   GROUP_NOT_STARTED = 1,
   PREVIOUS_DELIVERABLE_NOT_ACCEPTED,
   CURRENT_DELIVERABLE_NOT_STARTED,
   NOT_A_MEMBER_OF_A_GROUP,
   DOESNT_OWN_COURSE
}


export const BLANK_VIDEO_FILE_URL = 'https://s3-us-west-2.amazonaws.com/lv-resources/videos/noVideo.mp4';


export const ICON_VIDEO_MODULE_TYPE = "fas fa-video tocModuleTypeIconI";
export const ICON_TEXT_MODULE_TYPE = "fas fa-align-left tocModuleTypeIconI";
export const ICON_EXERCISE_MODULE_TYPE = "fas fa-pencil-alt tocModuleTypeIconI";



export const ADMIN_LIST = "admin list";
export const EDITOR_LIST = "editor list";
export const AUTHOR_LIST_SUFFIX = ` authors`;
export const MENTOR_LIST_SUFFIX = ` mentors`;
export const USER_LIST = "by user";

export const ADMIN_DISPLAY_NAME = "Administrator";
export const USER_DISPLAY_NAME = "User";
export const AUTHOR_DISPLAY_NAME = "Author";
export const EDITOR_DISPLAY_NAME = "Editor";
export const MENTOR_DISPLAY_NAME = "Mentor";

export const ADMIN_ROLE_TYPE = "Administrators";
export const USER_ROLE_TYPE = "AllUsers";
export const AUTHOR_ROLE_TYPE = "Authors";
export const EDITOR_ROLE_TYPE = "Editors";
export const MENTOR_ROLE_TYPE = "Mentors";


export const TRANSCRIBE_SERVICE_AWS = "AWS";
export const TRANSCRIBE_SERVICE_TRINT = "Trint";


export const CALENDAR_EVENT_MENTOR_FREE_TIME = "CALENDAR_EVENT_MENTOR_FREE_TIME";
export const CALENDAR_EVENT_USER_FREE_TIME = "CALENDAR_EVENT_USER_FREE_TIME";
export const CALENDAR_EVENT_MENTOR_MEETING = "CALENDAR_EVENT_MENTOR_MEETING";
export const CALENDAR_EVENT_USER = "CALENDAR_EVENT_USER";
export const CALENDAR_EVENT_1ON1_MEETING = "CALENDAR_EVENT_1ON1_MEETING";
export const CALENDAR_COLOR_MY_EVENT = "#E3EFFD";
export const CALENDAR_TEXT_COLOR_MY_EVENT = "#4788D9";
export const CALENDAR_COLOR_MY_EVENT_AS_MENTOR = CALENDAR_COLOR_MY_EVENT;
export const CALENDAR_TEXT_COLOR_MY_EVENT_AS_MENTOR = CALENDAR_TEXT_COLOR_MY_EVENT;
export const CALENDAR_COLOR_OTHER_MEMBERS_EVENT = "#96e690";
export const CALENDAR_TEXT_COLOR_OTHER_MEMBERS_EVENT = "#47a740";
export const CALENDAR_COLOR_MENTOR_EVENT = "#FFEEED";
export const CALENDAR_TEXT_COLOR_MENTOR_EVENT = "#F44336";
export const CALENDAR_COLOR_MY_1ON1 = "#FFEEED";
export const CALENDAR_TEXT_COLOR_MY_1ON1 = "#F44336";
export const CALENDAR_COLOR_OTHERS_1ON1 = "#EEFFED";
export const CALENDAR_TEXT_COLOR_OTHERS_1ON1 = "#42F436";
export const CALENDAR_COLOR_MENTOR_FREE_TIME_EVENT = "#d4d4d444";
export const CALENDAR_TEXT_COLOR_MENTOR_FREE_TIME_EVENT = "black";
export const CALENDAR_COLOR_USER_FREE_TIME_EVENT = "#d4d4d444";
export const CALENDAR_TEXT_COLOR_USER_FREE_TIME_EVENT = "black";


export const UPCOMING_EVENT_DELIVERABLE = "DELIVERABLE";


export const DELETE_SINGLE_EVENT = "DELETE_SINGLE_EVENT";
export const DELETE_FUTURE_EVENTS = "DELETE_FUTURE_EVENTS";
export const DELETE_ALL_EVENTS = "DELETE_ALL_EVENTS";

export const LAB_PAGE_TEMPLATE =
   `<div class="lab-page-outer-container">
<div class="lab-page-container">
   <div class="lab-page">
      <img src="https://s3-us-west-2.amazonaws.com/lv-resources/other/labIcon.svg" alt="" class="title-image">
      <div class="lab-page-title-text">
         <p class="lab-page-title-text-p">
            Put subheading here. 
         </p>
      </div>
   </div>
   <div class="lab-page-sub-items">
      <p>
         Put list item here.
      </p>
      <p>
         Put another list item here.
      </p>
      <br />
      <p>
         Put yet another list item here (that comes after a line break). 
      </p>
      <p>
         <i class="lab-page-sub-item-padding">
         Put italic sublist item here. 
         </i>
      </p>
      <p>
         <i class="lab-page-sub-item-padding">
         Put another italic sublist item here. 
         </i>
      </p>
      <p>
         <i class="lab-page-sub-item-padding">
         Put yet another italic sublist item here. 
         </i>
      </p>
      <br />
      <p>
         Put another list item here, after another line break. 
      </p>
   </div>
</div>
</div>
`

export const LAB_EXAMPLE =
   `<div class="lab-page-outer-container">
<div class="lab-page-container">
   <div class="lab-page">
      <img src="https://s3-us-west-2.amazonaws.com/lv-resources/other/labIcon.svg" alt="" class="title-image">
      <div class="lab-page-title-text">
         <p class="lab-page-title-text-p">
          Put your new understanding of the Linux file system into practice with this do-it-yourself project.
         </p>
      </div>
   </div>
   <div class="lab-page-sub-items">
      <p>
        Create a liveLinux  USB and mount it on your local hard drive.
      </p>
      <p>
        Be sure not to override any of your existing data! 
      </p>
      <br />
      <p>
        Open SSH sessions and explore options for installing Linux
      </p>
      <p>
         <i class="lab-page-sub-item-padding">
          Can you SSH to and from another network?
         </i>
      </p>
      <p>
         <i class="lab-page-sub-item-padding">
          Can you SSH into and out of a client app? 
         </i>
      </p>
      <p>
         <i class="lab-page-sub-item-padding">
          How about trying it using a smartphone as the second machine?
         </i>
      </p>
      <br />
      <p>
        Practice connecting between a variety of physical and virtual machines.
      </p>
   </div>
</div>
</div>
`

function getParameterByName(name) {

   let url = window.location.href;

   name = name.replace(/[\[\]]/g, "\\$&");
   var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
   if (!results) return null;
   if (!results[2]) return '';
   return decodeURIComponent(results[2].replace(/\+/g, " "));
}


export const LIVEPROJECT_TITLE="LIVEPROJECT_TITLE";

export const FEEDBACK = "FEEDBACK";
export const SUPPORT = "SUPPORT";

export const liveProjectIgnoreUserIdListForAuthorsAndMentors = [472358 /*l.h@g.c*/, 408260 /*m.b@g.c*/, 457406 /*m.b@f.h*/]

export const SISTERED_PRODUCTS_DURATION = 90;

export const VIDEO_PLAYBACK_TIME_INTERVAL = 3;  // seconds, used for isVideoCurrentlyPlaying

export const NORMAL_PRODUCT = "ProductType/NORMAL";
export const DISTRIBUTED_PRODUCT = "ProductType/DISTRIBUTED_COURSE";
export const MINILP_PRODUCT = "ProductType/MINILP";
export const MINILV_PRODUCT = "ProductType/MINILV";

export const MENTORUI_APPROVED = "Approved";
export const MENTORUI_NOT_APPROVED = "Not approved";

export const CERTIFICATE_TEST_THRESHOLD = 70;
export const CERTIFICATION = 'CERTIFICATION';

export const HINT_ONE_TEXT = "help";
export const HINT_TWO_TEXT = "more help";
export const HINT_THREE_TEXT = "partial solution";
export const HINT_FOUR_TEXT = "full solution";